module.exports = __webpack_public_path__ + "img/hitachi.0834895.png";